export default "__VITE_ASSET__D$NPDg5i__"